import { useEffect, useState } from 'react';
import pacote from './pacote';

// quantos esperam atendimento no chat (numero no item Atendimento do menu), com o som das mensagens e os lembretes de
// tarefa em qualquer tela: a mesma regra da Central, vinda do pacote (ver pacote.js)
export function useEntradaChat(ligado){

    const [quantos, alterarQuantos] = useState(0);

    useEffect(() => {

        if(!ligado){
            alterarQuantos(0);
            return;
        }

        return pacote.vigiarEntrada(alterarQuantos);

    }, [ligado]);

    return quantos;
}
